import { useCallback, useMemo } from 'react';
import { useAPI } from '@/services/index';
import { useGetFundCodeFromQuery } from '@/modules/invest/hooks/useGetFundCodeFromQuery';

export const useGetFundFAQs = () => {
  const fundCode = useGetFundCodeFromQuery();

  const {
    data: fundDetail,
    isFetching: isFetchingFundDetail,
    isLoading: isLoadingFundDetail,
    refetch: refetchFundDetail,
    error: errorFundDetail,
    isError: isErrorFundDetail,
  } = useAPI(['fund', 'getFundDetail'], {
    input: {
      code: fundCode,
    },
  });
  const {
    data: fundFAQs,
    isFetching: isFetchingFundFAQs,
    isLoading: isLoadingFundFAQs,
    refetch: refetchFundFAQs,
    error: errorFundFAQs,
    isError: isErrorFundFAQs,
  } = useAPI(['baseInfo', 'getFAQShortAnswer'], {
    input: {
      id: fundDetail?.faqCategoryId!,
    },
    reactQueryOptions: {
      enabled: !!fundDetail?.faqCategoryId,
    },
  });

  const isFetching = isFetchingFundDetail || isFetchingFundFAQs;
  const isLoading = isLoadingFundDetail || isLoadingFundFAQs;
  const isError = isErrorFundDetail || isErrorFundFAQs;

  const errorMessage: string | undefined = useMemo(() => {
    if (!isErrorFundFAQs && !isErrorFundDetail) {
      return undefined;
    }
    return errorFundDetail?.message || errorFundFAQs?.message || '';
  }, [errorFundDetail, errorFundFAQs, isErrorFundDetail, isErrorFundFAQs]);

  const refetchOnError = useCallback(async () => {
    isErrorFundDetail && (await refetchFundDetail());
    isErrorFundFAQs && (await refetchFundFAQs());
  }, [isErrorFundDetail, isErrorFundFAQs, refetchFundDetail, refetchFundFAQs]);

  return {
    fundFAQs,
    isFetching,
    isLoading,
    errorMessage,
    refetchOnError,
    isError,
    isLoadingFundDetail,
  };
};
